import inMemoryJWT from "../../auth/inMemoryJwt";
import { urlServer } from "../../config/GlobalConstant";
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

export const createCampaign = (data, history) => async dispatch => {
    await fetch(`${urlServer}publiccampaigns/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: "CREATE_CAMPAIGN",
                    payload: respJson.data
                });
                history.push("/")
            } else {
                if (respJson?.error?.error?.code ==="ERR088") {
                    Toast.fire({
                        icon: "error",
                        title: "No tienes ecopuntos"
                    })
                }
                if (respJson?.error?.error?.code ==="ERR090") {
                    Toast.fire({
                        icon: "error",
                        title: "No tienes suficientes ecopuntos"
                    })
                }
            }
        })
        .catch(error => {
            console.log()
        })
}